import { useProfileStore } from '../store/useProfileStore';
import { getById as apiGetById, put as apiPut, patch as apiPatch } from './apiService';
import { logTrace } from './loggerService';
import { Profile } from '../types/profile';
import { Team } from '../types/team';

// Setter for active profile
export function setActiveProfile(profile: Profile | null) {
  useProfileStore.getState().setActiveProfile(profile);
}

// Getter for active profile
export function getActiveProfile(): Profile | null {
  const profile = useProfileStore.getState().activeProfile;
  logTrace('getActiveProfile', undefined, { activeProfile: profile });
  return profile;
}

// Setter for active team
export function setActiveTeam(team: Team | null) {
  useProfileStore.getState().setActiveTeam(team);
}

// Getter for active team
export function getActiveTeam(): Team | null {
  return useProfileStore.getState().activeTeam;
}

// API calls
export async function getById(profileId: string, serviceKey?: string): Promise<Profile> {
  return apiGetById<Profile>('/profile', profileId, 'expand=userPlan', serviceKey);
}

export async function put(profile: Profile): Promise<Profile> {
  return apiPut<Profile>(`/profile/${profile.id}`, profile);
}

export async function patch(profile: Partial<Profile> & { id: string }): Promise<Profile> {
  return apiPatch<Profile>(`/profile/${profile.id}`, profile);
}

// Convenience export
export const profileService = {
  setActiveProfile,
  getActiveProfile,
  setActiveTeam,
  getActiveTeam,
  getById,
  put,
  patch,
};
